<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({
                      name: 'AdministratoAreasListCreate',
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon left>mdi-plus</v-icon>
                {{ $t("newArea") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>
              {{ item.id }}
            </v-btn>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="
                    [
                      $router.push({
                        name: 'AdministratoAreasListEdit',
                        params: { id: item.id },
                      }),
                      showDialog(),
                    ]
                  "
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("edit") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "administrator-areas-list",
  components: {
    HeaderPrint,
  },

  data: () => ({
    search: "",
    data: [],
  }),
  mounted() {
    this.getAreasList();
  },
  computed: {
    headers() {
      return [
        { text: "Id Area", value: "id" },
        { text: this.$t("newArea"), value: "name" },
        { text: this.$t("subAreaOf"), value: "nome_regiao" },
        { text: this.$t("description"), value: "descricao" },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center d-print-none",
        },
      ];
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
  },
  watch: {
    refresh(val) {
      val && this.getAreasList();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    async getAreasList() {
      const body = {
        id_regiao: "",
      };
      const response = await this.$request.post(
        "administrator/areas/list",
        body
      );
      if (response.length == 0) return;
      this.data = response.dados;
    },
    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
  },
};
</script>
